// src/components/Dashboard.js

import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useAuth } from '../context/AuthContext';
    
const Dashboard = () => {
  const { currentUser } = useAuth();
  
  const features = [
    "Real-time messaging is now fully enabled.",
    "See who's online with our new presence feature.",
    "Your conversations are now displayed in a beautiful new dark theme.",
    "Editable User Profiles: Update your name and photo from the sidebar.",
    "Full emoji support has been added to chat!",
    "You can send 20-sec voice messages.",
    "The app is now fully responsive for a great mobile experience.",
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" gutterBottom>
              Welcome back, {currentUser?.displayName}!
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Select a chat from your connections to continue a conversation, or find new people to connect with.
            </Typography>
    
            {/* --- THIS IS THE UPDATED SECTION --- */}
            <Paper sx={{ p: 3, mt: 4, backgroundColor: 'background.paper', textAlign: 'center' }}>
                <Typography variant="h6">
                    What's new in Zinlanka?
                </Typography>
                
                {/* We now use MUI's List components for perfect alignment */}
                <List sx={{ display: 'inline-block', textAlign: 'left', p: 0, mt: 1 }}>
                  {features.map((feature, index) => (
                    <ListItem key={index} sx={{ py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: '24px', color: 'text.secondary' }}>
                        •
                      </ListItemIcon>
                      <ListItemText 
                        primary={feature} 
                        primaryTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                      />
                    </ListItem>
                  ))}
                </List>
            </Paper>
        </Box>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="caption" color="text.secondary">
                © {new Date().getFullYear()} Kushan & Co.Technologies LLC. All Rights Reserved.
            </Typography>
        </Box>
    </Box>
  );
};
    
export default Dashboard;